<p-fieldset
  legend="eQMS Scope Configuration"
  class="eQMSScopeConfiguarationPlaceHolder"
>
  <div class="eQMSScopeConfigurationTree">
    <p-treeSelect
      selectionMode="single"
      [(ngModel)]="selectedNode"
      [options]="treeData"
      (onNodeSelect)="nodeSelect($event)"
      (onNodeUnselect)="nodeUnselect($event)"
      [placeholder]="treeSelectPlaceHolderText"
      [filter]="true"
      [showClear]="true"
    ></p-treeSelect>
  </div>
  <div *ngIf="isEqmsScopeSelected" class="mt-2">
    <p-pickList
      #pickList
      [sourceStyle]="{ height: '25rem' }"
      [targetStyle]="{ height: '25rem' }"
      [filterBy]="pickListFilterField"
      [sourceFilterPlaceholder]="filterPlaceHolderText"
      [targetFilterPlaceholder]="filterPlaceHolderText"
      [responsive]="true"
      [sourceHeader]="sourceHeaderTitle"
      [targetHeader]="targetHeaderTitle"
      [source]="availableList"
      [showSourceControls]="false"
      [showTargetControls]="false"
      [target]="inUseList"
      (onMoveToTarget)="onMoveToTarget($event)"
      (onMoveToSource)="onMoveToSource($event)"
      (onMoveAllToTarget)="onMoveAllToTarget($event)"
      (onMoveAllToSource)="onMoveAllToSource($event)"
      (onTargetFilter)="onTargetFilter()"
    >
      <ng-template let-template pTemplate="item">
        <div
          [ngClass]="{
            'parent-document-template': template.isParentScopeOfDocumentTemplate
          }"
        >
          <em
            *ngIf="template.isParentScopeOfDocumentTemplate"
            class="mr-2 fa fa-solid fa-sitemap"
          ></em>
          <app-label labelText="{{ template.name }}"></app-label>
        </div> </ng-template
    ></p-pickList>
  </div>
</p-fieldset>
